import { call, put, takeLatest } from 'redux-saga/effects';
import { httpRequestsOnLoadActions } from '../../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../../http_requests_on_success';
import { httpRequestsOnErrorsActions } from '../../http_requests_on_errors';
import {
    CREATE_PROGRESS_REPORT,
    DELETE_PROGRESS_REPORT,
    EDIT_PROGRESS_REPORT,
    GET_PROGRESS_REPORTS,
    GET_PROGRESS_REPORTS_BY_ID,
    GET_PROGRESS_REPORTS_BY_ID_SUCCESS,
    GET_PROGRESS_REPORTS_SUCCESS,
    SET_PROGRESS_REPORT_STATUS,
} from './progressReport.types';
import { authService } from './progressReport.service';

/** ProgressReports */

function* getProgressReports({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    try {
        const res = yield call(authService.getProgressReportsService, payload?.clientId, payload?.params);
        yield put({
            type: GET_PROGRESS_REPORTS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}
function* getProgressReportById({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    try {
        const res = yield call(authService.getProgressReportByIdService, payload?.id);
        yield put({
            type: GET_PROGRESS_REPORTS_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* createProgressReport({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const report = yield call(authService.createProgressReportService, payload?.clientId, payload?.body);
        const res = yield call(authService.getProgressReportByIdService, report?.data?.data?.id);
        yield put({
            type: GET_PROGRESS_REPORTS_BY_ID_SUCCESS,
            payload: res.data,
        });
        // const res = yield call(authService.getProgressReportsService, payload?.params);
        // yield put({
        //     type: GET_PROGRESS_REPORTS_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, report?.data));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* editProgressReport({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.editProgressReportService, payload?.id, payload?.body);
        if (payload?.body?.status) {
            yield put({ type: SET_PROGRESS_REPORT_STATUS, payload: { id: payload.id, status: payload.body.status } });
        }
        // const res = yield call(authService.getProgressReportsService, payload?.params);
        // yield put({
        //     type: GET_PROGRESS_REPORTS_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, res?.data));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* deleteProgressReport({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.deleteProgressReportService, payload?.id);
        // const res = yield call(authService.getProgressReportsService, payload?.params);
        // yield put({
        //     type: GET_PROGRESS_REPORTS_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

export const watchProgressReports = function* watchProgressReportsAuth() {
    /** ProgressReports  */
    yield takeLatest(GET_PROGRESS_REPORTS, getProgressReports);
    yield takeLatest(GET_PROGRESS_REPORTS_BY_ID, getProgressReportById);
    yield takeLatest(CREATE_PROGRESS_REPORT, createProgressReport);
    yield takeLatest(EDIT_PROGRESS_REPORT, editProgressReport);
    yield takeLatest(DELETE_PROGRESS_REPORT, deleteProgressReport);
    /** End */
};
